import { useTranslation, Trans } from 'react-i18next';
import React, { useMemo } from 'react';
import { InteractEligibilities } from '@debank/content-editor';
import cx from 'clsx';

import { Tips } from '@/components';
import { PostInteractPermission } from '@/views/Stream';

import style from './index.module.scss';
import { useEligibilityBadgeName } from '@/hooks/useEligibilityBadgeName';
import { useGroupDetail } from '@/views/Group/hooks';
export const RestrictionTip = ({
  data,
  className,
}: {
  data?: PostInteractPermission;
  className?: string;
}) => {
  const { t } = useTranslation();

  const badgeName = useEligibilityBadgeName({ badgeEligibility: data?.has_one_of_badges });
  const { data: groupDetail } = useGroupDetail(data?.is_group_member);
  const restriction = useMemo(() => {
    return (
      data &&
      // eslint-disable-next-line array-callback-return
      InteractEligibilities.map(x => {
        if (x.name in data) {
          if (x.name === 'has_one_of_badges') {
            // @ts-ignore
            return x.desc?.(badgeName);
          } else if (x.name === 'is_group_member') {
            // @ts-ignore
            return x.desc?.(groupDetail?.name);
          }
          // @ts-ignore
          return x.desc?.(data[x.name]);
        }
      }).filter(x => !!x)
    );
  }, [badgeName, data, groupDetail?.name]);

  return restriction?.length ? (
    <Tips
      className={cx(style.tipWrap, className)}
      iconClassName={style.tipIcon}
      title={
        <div className={style.tipContent}>
          {restriction.map((x, i) => (
            <div key={i}>• {x}</div>
          ))}
        </div>
      }>
      <span className={style.restrictLable}>
        <Trans i18nKey="RestrictionTip.197p2h8" count={restriction?.length || 0}>
          <span className={style.restrictCount}>{restriction.length}</span>
          restriction
        </Trans>
      </span>
    </Tips>
  ) : (
    <span className={cx(style.restrictLable, className)}>{t('RestrictionTip.1n92619')}</span>
  );
};
